import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useColorTokens } from '@/app/themes';

const BdiCdiGraphic = () => {
  const { green, red, steel, yellow } = useColorTokens();

  return (
    <Box
      px={8}
      py={6}
      position='relative'
      role='img'
      aria-label='BDI - CDI Framework'
    >
      <Box
        sx={{
          position: 'absolute',
          width: '85%',
          height: '2px',
          bgcolor: 'grey.400',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          '::before': {
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            left: '0',
            top: '0',
            transform: 'translateY(-40%) rotate(135deg)',
            border: 1,
            borderColor: 'grey.400',
            borderWidth: '0 2px 2px 0',
            padding: '4px',
          },
          '::after': {
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            right: '0',
            top: '0',
            transform: 'translateY(-40%) rotate(-45deg)',
            border: 1,
            borderColor: 'grey.400',
            borderWidth: '0 2px 2px 0',
            padding: '4px',
          },
        }}
      />

      <Typography
        variant='body3'
        noWrap
        sx={{
          position: 'absolute',
          left: 0,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        Low BDI
      </Typography>

      <Typography
        variant='body3'
        noWrap
        sx={{
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        High BDI
      </Typography>

      <Box
        sx={{
          position: 'absolute',
          width: '2px',
          height: '88%',
          bgcolor: 'grey.400',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          '::before': {
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            left: '0',
            top: '0',
            transform: 'translateX(-40%) rotate(-135deg)',
            border: 1,
            borderColor: 'grey.400',
            borderWidth: '0 2px 2px 0',
            padding: '4px',
          },
          '::after': {
            content: '""',
            display: 'inline-block',
            position: 'absolute',
            left: '0',
            bottom: '0',
            transform: 'translateX(-40%) rotate(45deg)',
            border: 1,
            borderColor: 'grey.400',
            borderWidth: '0 2px 2px 0',
            padding: '4px',
          },
        }}
      />

      <Typography
        variant='body3'
        noWrap
        sx={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        High CDI
      </Typography>
      <Typography
        variant='body3'
        noWrap
        sx={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        Low CDI
      </Typography>

      <Box
        display='grid'
        gap={2.5}
        gridTemplateColumns='1fr 1fr'
        gridTemplateRows='1fr 1fr'
      >
        <Box
          textAlign='right'
          p={2}
          pt={3.5}
          bgcolor={yellow[10]}
          borderRadius={1}
        >
          <Typography fontWeight={600} color={yellow[200]}>
            Opportunity Markets
          </Typography>
          <Typography variant='body2' color='textTertiary' pt={0.5}>
            Low market share, good market potential
          </Typography>
          <Typography variant='body3' component='p' pt={1.5}>
            High growth potential, boost media to attract more consumers and dig
            into potential reasons for low market share.
          </Typography>
        </Box>

        <Box p={2} pt={3.5} bgcolor={green[10]} borderRadius={1}>
          <Typography fontWeight={600} color={green[200]}>
            Key Markets
          </Typography>
          <Typography variant='body2' color='textTertiary' pt={0.5}>
            High market share, good market potential
          </Typography>
          <Typography variant='body3' component='p' pt={1.5}>
            Protect from competitors, boost media and stay competitive.
          </Typography>
        </Box>

        <Box
          textAlign='right'
          p={2}
          pt={3.5}
          bgcolor={red[10]}
          borderRadius={1}
        >
          <Typography fontWeight={600} color={red[200]}>
            Markets with No Potential
          </Typography>
          <Typography variant='body2' color='textTertiary' pt={0.5}>
            Low market share, poor market potential
          </Typography>
          <Typography variant='body3' component='p' pt={1.5}>
            Avoid as to not waste media dollars.
          </Typography>
        </Box>

        <Box p={2} pt={3.5} bgcolor={steel[50]} borderRadius={1}>
          <Typography fontWeight={600} color={steel[700]}>
            Maintenance Markets
          </Typography>
          <Typography variant='body2' color='textTertiary' pt={0.5}>
            High market share, potential for sales decline
          </Typography>
          <Typography variant='body3' component='p' pt={1.5}>
            Little growth, monitor closely and be aware of over-saturation.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BdiCdiGraphic;
